import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppEvent } from './app-event.service';

@Component({
	selector: 'app-event-detail',
	templateUrl: './app-event-detail.component.html',
	styleUrls: ['./app-event-detail.component.css'],
	standalone: false
})
export class AppEventDetailComponent {

	event: AppEvent;
	prettyMetadata: string = '';

	constructor(
		public dialogRef: MatDialogRef<AppEventDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { event: AppEvent }
	) {
		this.event = data.event;
		this.prettyMetadata = this.prettyJson(this.event.metadata);
	}

	private prettyJson(raw: string): string {
		if (!raw) return '';
		try {
			return JSON.stringify(JSON.parse(raw), null, 2);
		} catch {
			return raw;
		}
	}

	close() { this.dialogRef.close(); }
}
